import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import supabase from '../../services/supabaseClient';
import Button from '../../components/Button';
import Input from '../../components/Input';
import Icon from '../../components/Icon';
import { useTheme } from '../../contexts/ThemeContext';
import './styles.css';

const RedefinirSenha: React.FC = () => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Quando esta página é aberta a partir do link do Supabase, o usuário já está autenticado via token magic link
    // Se não houver sessão, redirecionamos para login
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) {
        navigate('/login');
      }
    };
    checkSession();
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password || !confirmPassword) {
      setError('Preencha a nova senha em ambos os campos');
      return;
    }
    if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const { error: updateError } = await supabase.auth.updateUser({ password });
      if (updateError) throw updateError;
      setSuccess(true);
    } catch (err) {
      console.error(err);
      setError('Erro ao redefinir senha, tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`body-wrapper auth-wrapper d-flex align-items-stretch ${darkMode ? 'dark-mode' : ''}`}>
      <div className="d-flex flex-grow flex-column-reverse flex-sm-row w-100">
        <div className="auth-bg py-5 py-sm-0 col-sm-6">
          <p className="auth-credits py-5">
            <span className="footer-message">
              Feito com <Icon name="heart" size={16} color="red" /> Trending<br />
            </span>
          </p>
        </div>
        <div className="auth-panel-wrapper col">
          <div className="auth-panel py-5">
            <img 
              src="/logo-trading.png" 
              alt="Trading Logo"
            />
            <div className="auth-header">
              <h4 className="auth-title">Redefinir Senha</h4>
              <p className="auth-subtitle">
                Crie sua nova senha abaixo
              </p>
            </div>

            {success ? (
              <div className="success-message">
                <div className="alert alert-success">
                  <Icon name="mail" size={24} color="green" />
                  <p>Senha redefinida com sucesso!</p>
                </div>
                <Button type="button" variant="auth" fullWidth onClick={() => navigate('/login')}>
                  Ir para Login
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="form-group">
                  <Input
                    label="Nova Senha"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Digite a nova senha"
                    required
                  />
                </div>

                <div className="form-group">
                  <Input
                    label="Confirme a Senha"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirme a nova senha"
                    required
                  />
                </div>

                <div className="form-group py-4">
                  <Button type="submit" variant="auth" fullWidth disabled={loading}>
                    {loading ? 'Redefinindo...' : 'Redefinir Senha'}
                  </Button>
                </div>

                <p className="tip text-center mt-2">
                  <Link to="/login" className="auth-link">
                    Voltar para o Login
                  </Link>
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedefinirSenha;
